import React from 'react'
import { Dropdown, Space, MenuProps, Typography } from 'antd'
import { FormattedMessage, injectIntl } from 'react-intl'
import { DownOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

const items: MenuProps['items'] = [
  {
    key: '1',
    type: 'group',
    label: <FormattedMessage description='testResults' id='generic.testResults'/>,
    children: [
      {
        key: '1-1',
        label: (
          <Link to="/statistics-overview">
            <FormattedMessage description='seeResults' id='navigation.results.seeResults'/>
          </Link>
        )
      },
    ],
  },
]

export const ResultsDropdown = () => {
  return (
    <Dropdown menu={{ items }}>
      <Space style={{cursor: 'pointer'}}>
        <Typography.Title level={5} style={{marginTop: '5px'}}>
          <FormattedMessage description="testResults" id="generic.testResults"/>
        </Typography.Title>
        <DownOutlined />
      </Space>
    </Dropdown>
  )
}

export default injectIntl(ResultsDropdown)